import { render, staticRenderFns } from "./Privacy-Android2.vue?vue&type=template&id=bc52a374&scoped=true"
import script from "./Privacy-Android2.vue?vue&type=script&lang=js"
export * from "./Privacy-Android2.vue?vue&type=script&lang=js"
import style0 from "./Privacy-Android2.vue?vue&type=style&index=0&id=bc52a374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc52a374",
  null
  
)

export default component.exports